import { render, staticRenderFns } from "./AwsRoleAssumption.vue?vue&type=template&id=9a812d32&scoped=true&"
import script from "./AwsRoleAssumption.vue?vue&type=script&lang=js&"
export * from "./AwsRoleAssumption.vue?vue&type=script&lang=js&"
import style0 from "./AwsRoleAssumption.vue?vue&type=style&index=0&id=9a812d32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a812d32",
  null
  
)

export default component.exports